import { mapState } from 'pinia';
import stores from 'store/modules';
import UserMixin from 'mixins/user';
import EarlyUpgradeMixin from 'mixins/early-upgrade';
import OrganizationMixin from 'mixins/organization';
import CallingComplianceMixin from 'views/Settings/Organization/Settings/Compliance/Calling/mixins/calling';

export default {
    mixins: [UserMixin, EarlyUpgradeMixin, OrganizationMixin, CallingComplianceMixin],

    computed: {
        getAvailableNumbers() {
            return [
                ...this.numbers.filter(
                    (item) =>
                        item.isTollFree &&
                        !item.isSendToTollFreeVerification &&
                        !item.statusInternalReview &&
                        !item.isAircall
                ),
                ...this.unassignedNumbers.filter(
                    (item) =>
                        item.isTollFree &&
                        !item.isSendToTollFreeVerification &&
                        !item.statusInternalReview &&
                        !item.isAircall
                ),
            ];
        },

        ...mapState(stores.User, ['user']),
        ...mapState(stores.ComplianceProfile, ['tollFreeProfileItems', 'profileBusiness']),
        ...mapState(stores.Number, ['numbers', 'unassignedNumbers']),
        ...mapState(stores.Organization, ['featureFlags']),
    },

    methods: {
        handleShowAnotherModals() {
            return true;
        },

        handleUpdateBusinessProfile() {
            if (this.hasNotBillingSources && !this.isOnTrial) {
                this.showPaymentMethods();

                return false;
            }

            if (this.checkLegacyAccess || this.checkPlanFreeMonthly) {
                this.showEarlyUpgrade();

                return false;
            }
        },

        handleCheckInviteMembers() {
            window.publicApiReact?.handleCheckInviteMembers('members');
        },

        handleCheckToolFreeNumbers(status = false, item = null, type = null) {
            if (
                (this.isOnTrial || this.checkLegacyAccess || this.checkPlanFreeMonthly) &&
                (this.featureFlags.salesmsg_design_v2_compliance_toll_free ||
                    this.tollFreeProfileItems.length)
            ) {
                this.showEarlyUpgrade();

                return;
            }

            if (this.getAvailableNumbers?.length > 0) {
                this.$store.dispatch('handleShowTollFreeVerificationModal', {
                    status: true,
                    item: item,
                });

                return false;
            }

            this.$store.dispatch('handleShowTollFreeAddNumberModal', {
                status: true,
            });
        },
    },

    mounted() {
        window.publicApiVue = {
            onDeleteToolFreeProfileModal: (item) => {
                this.$store.dispatch('handleShowTollFreeDeleteModal', {
                    item: item,
                    status: true,
                });
            },

            onContinueTollFreeProfileModal: (item) => {
                this.$store.dispatch('setTollFreeDataForRecoveredVerification', item);
                this.$store.dispatch('handleShowTollFreeVerificationModal', {
                    status: true,
                    item: item,
                });
            },

            onCheckToolFreeNumbers: () => {
                this.handleCheckToolFreeNumbers(true, null, 'tollfree');
            },

            showTrustedCallingBuy: (type) => {
                this.handleShowTrustedCallingBuy(true, type);
            },

            showVoiceIntegrityModal: () => {
                this.$store.dispatch('handleShowVoiceIntegrityModal', true);
            },

            showShakenStirAdvanced: () => {
                this.handleShowShakenStirAdvanced(true);
            },

            showShakenStirDeleteModal: () => {
                this.handleShowShakenStirDeleteModal(true);
            },

            showCNAMCallerID: () => {
                this.handleShowCNAMCallerID(true);
            },

            showCNAMCallerEdit: (item) => {
                this.handleShowCNAMCallerEdit(item);
            },

            showCNAMCallerDelete: (item) => {
                this.handleShowCNAMCallerDelete(item);
            },

            fetchMe: async () => {
                await this.$store.dispatch('getUserMe');
            },

            fetchNumbers: async () => {
                await Promise.all([
                    this.$store.dispatch('getNumbers'),
                    this.$store.dispatch('getNumbersUnassigned'),
                ]);
            },

            showEarlyUpgrade: () => {
                if (this.isAgencyWithoutSubscription) {
                    this.showEarlyUpgrade();
                }
            },
        };
    },
};
